import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { DateTime } from "luxon";

const DayNavigator = ({ selectedDate, isToday, onPrevious, onNext, onToday }) => {
  const dt = DateTime.fromJSDate(selectedDate);
  const yesterday = DateTime.now().minus({ days: 1 });
  const tomorrow = DateTime.now().plus({ days: 1 });

  const getDateLabel = () => {
    if (isToday) return `Today, ${dt.toFormat("ccc MMM d")}`;
    if (dt.hasSame(yesterday, "day")) return `Yesterday, ${dt.toFormat("ccc MMM d")}`;
    if (dt.hasSame(tomorrow, "day")) return `Tomorrow, ${dt.toFormat("ccc MMM d")}`;
    return dt.toFormat("cccc, MMM d");
  };

  return (
    <div className="flex items-center gap-x-2">
      <button
        onClick={onPrevious}
        className="rounded-md p-1.5 text-ink-400 hover:text-ink-600 hover:bg-cream-200 transition-colors"
        aria-label="Previous day"
      >
        <ChevronLeftIcon className="size-5" />
      </button>

      <span className="text-sm font-semibold text-ink-900 min-w-[160px] text-center">
        {getDateLabel()}
      </span>

      <button
        onClick={onNext}
        className="rounded-md p-1.5 text-ink-400 hover:text-ink-600 hover:bg-cream-200 transition-colors"
        aria-label="Next day"
      >
        <ChevronRightIcon className="size-5" />
      </button>

      {!isToday && (
        <button
          onClick={onToday}
          className="ml-1 rounded-md bg-cream-200 px-2.5 py-1 text-xs font-medium text-ink-600 hover:bg-cream-300 transition-colors"
        >
          Today
        </button>
      )}
    </div>
  );
};

export default DayNavigator;
